import React from 'react';
import classNames from 'classnames';
import useNavigation from '../../../hooks/useNavigation';
import useLanguage from "../../../hooks/useLanguage";

const Question = ({ answer }) => {
  const { setInitialMessage, initialMessage: selectedInitialMessage } = useNavigation();

  const { language } =   useLanguage();

  const onClick = async () => {
    setInitialMessage(answer);
  };

  // Find translation for intent or fallback to ENG
  const translation = answer.translations.find((translation) => translation.language.toLowerCase() === language) || answer.translations.find((translation) => translation.language.toLowerCase() === 'en');

  return (
    <button type="button" className={
      classNames({
        button: true,
        block: true,
        active: selectedInitialMessage && selectedInitialMessage.id === answer.id
      })
    } onClick={onClick}>
      {translation.text}
    </button>
  );
};

export default Question;
